export default __webpack_public_path__ + "static/media/frontdoor_house4.b1af7622.jpeg";